export default __webpack_public_path__ + "static/media/MyNatureFooter.58602c03.jpeg";